import React from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../contexts/DataContext';
import Loading from '../components/Loading';
import './Blog.css';

const Blog = () => {
  const { blogPosts, loading } = useData();

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="blog-page">
      <section className="page-header">
        <div className="container">
          <h1>Blog</h1>
          <p>Cele mai recente știri și articole despre design și inginerie</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {blogPosts.length > 0 ? (
            <div className="blog-grid">
              {blogPosts.map(post => (
                <article key={post.id} className="blog-card card">
                  {post.featured_image && (
                    <Link to={`/blog/${post.slug}`}>
                      <img src={post.featured_image} alt={post.title} />
                    </Link>
                  )}
                  <div className="card-content">
                    <div className="post-meta">
                      <span className="author">📝 {post.author}</span>
                      <span className="date">
                        📅 {new Date(post.published_date).toLocaleDateString('ro-RO')}
                      </span>
                    </div>
                    
                    <Link to={`/blog/${post.slug}`}>
                      <h2>{post.title}</h2>
                    </Link>
                    
                    <p className="excerpt">{post.excerpt}</p>
                    
                    {post.categories && post.categories.length > 0 && (
                      <div className="categories">
                        {post.categories.map(cat => (
                          <span key={cat.id} className="category-tag">{cat.name}</span>
                        ))}
                      </div>
                    )}
                    
                    <Link to={`/blog/${post.slug}`} className="read-more">
                      Citește mai mult →
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <p className="no-data">Nu există postări de blog disponibile încă.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default Blog;

